import React from "react";
import Ingredient from "../Ingredient";
import whole from "../../assets/images/ingredients/Corn.png";
import sliced from "../../assets/images/ingredients/Corn_kernels.png";

const Corn = ({ onClick, changeable=true, changed, hideable=true }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    return (
        <Ingredient
            name="Corn"
            image={[whole, sliced]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={handleClick}
        />
    );
};

export default Corn;